import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "What is digital marketing and why do I need it?",
      answer: "Digital marketing consists of every marketing activity which operates through electronic devices including online platforms. Your business requires digital marketing because it provides the most powerful approach to connect with target audiences while establishing brand recognition and increasing sales during this digital era."
    },
    {
      question: "What specific services do you offer?",
      answer: "Our services encompass digital marketing solutions through Search Engine Optimization (SEO), Social Media Marketing (SMM), Pay-Per-Click (PPC), Content Marketing, Email Marketing, and Website Design & Development."
    },
    {
      question: "How long does it take to see results from digital marketing?",
      answer: "The results timeframe depends on the approach and the business sector. Outcomes from PPC emerge quickly, while SEO and content marketing show substantial effects after 3 to 6 months."
    },
    {
      question: "How do you measure the success of your digital marketing campaigns?",
      answer: "We evaluate success through key performance indicators including website traffic, lead generation, conversion rates, return on ad spend (ROAS), social media engagement, and keyword rankings. We provide periodic reports to maintain transparency."
    },
    {
      question: "Do I need a website to use your digital marketing services?",
      answer: "Most digital marketing activities require a well-optimized website as your main digital base. We offer website development support if needed."
    },
    {
      question: "How do I get started with your services?",
      answer: "Getting started is easy! Contact us via our website, phone, or email to schedule a complimentary consultation. We'll explore your business objectives and create a customized digital marketing plan."
    },
    {
      question: "Is digital marketing expensive?",
      answer: "Digital marketing strategies can fit various budgets. We create individualized strategies that optimize your return on investment for maximum value."
    }
  ];

  return (
    <div className="max-w-4xl min-h-screen mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Find answers to common questions about our digital marketing services
        </p>
      </div>

      <div className="space-y-6">
        {faqData.map((faq, index) => (
          <div 
            key={index} 
            className={`bg-white rounded-xl  border border-gray-100 overflow-hidden transition-all duration-300 ${
              openIndex === index ? '' : 'hover:'
            }`}
          >
            <div 
              className="flex justify-between items-center p-6 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <h2 className="text-xl font-semibold text-gray-800">{faq.question}</h2>
              <button className="text-gray-500 hover:text-[#FD5F20] transition-colors">
                {openIndex === index ? (
                  <Minus size={24} className="text-[#FD5F20]" />
                ) : (
                  <Plus size={24} />
                )}
              </button>
            </div>
            
            {openIndex === index && (
              <div className="px-6 pb-6 pt-0 animate-fadeIn">
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default FAQPage;